import { apiProxyRequest } from "Api/apiProxyRequest";

import type {
  AlertMode,
  ProjectUsageAlert,
  ProjectUsageAlertUpdate
} from "../types";

// The endpoint patches a single alert at a time, so callers updating more than
// one type issue one request per type. The API requires every patch to carry
// `active`, `threshold` and `mode`; the traffic UI has no mode control, so
// default `mode` to "projection" (matching the profile spend alert).
export const patchProjectUsageAlert = (
  billingProfileId: string,
  projectId: string,
  alert: ProjectUsageAlertUpdate,
  mode: AlertMode = "projection"
) =>
  apiProxyRequest<ProjectUsageAlert>(
    `/billing/profiles/${billingProfileId}/alerts/projects/${projectId}/usage`,
    "PATCH",
    { ...alert, config: { ...alert.config, mode } }
  );
